import { render, staticRenderFns } from "./OPDetailTransation.vue?vue&type=template&id=7ba9ecb0&"
import script from "./OPDetailTransation.vue?vue&type=script&lang=js&"
export * from "./OPDetailTransation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports